// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m["default"] || m;
};

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": function componentNodeModulesGatsbyPluginOfflineAppShellJs() {
    return import("./../gatsby-plugin-offline/app-shell.js"
    /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */
    );
  },
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-about-js": function componentSrcPagesAboutJs() {
    return import("./../../src/pages/about.js"
    /* webpackChunkName: "component---src-pages-about-js" */
    );
  },
  "component---src-pages-amp-technologies-js": function componentSrcPagesAmpTechnologiesJs() {
    return import("./../../src/pages/amp-technologies.js"
    /* webpackChunkName: "component---src-pages-amp-technologies-js" */
    );
  },
  "component---src-pages-blog-js": function componentSrcPagesBlogJs() {
    return import("./../../src/pages/blog.js"
    /* webpackChunkName: "component---src-pages-blog-js" */
    );
  },
  "component---src-pages-download-js": function componentSrcPagesDownloadJs() {
    return import("./../../src/pages/download.js"
    /* webpackChunkName: "component---src-pages-download-js" */
    );
  },
  "component---src-pages-faq-js": function componentSrcPagesFaqJs() {
    return import("./../../src/pages/faq.js"
    /* webpackChunkName: "component---src-pages-faq-js" */
    );
  },
  "component---src-pages-features-js": function componentSrcPagesFeaturesJs() {
    return import("./../../src/pages/features.js"
    /* webpackChunkName: "component---src-pages-features-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-pricing-js": function componentSrcPagesPricingJs() {
    return import("./../../src/pages/pricing.js"
    /* webpackChunkName: "component---src-pages-pricing-js" */
    );
  },
  "component---src-pages-privacy-policy-js": function componentSrcPagesPrivacyPolicyJs() {
    return import("./../../src/pages/privacy-policy.js"
    /* webpackChunkName: "component---src-pages-privacy-policy-js" */
    );
  },
  "component---src-pages-terms-use-js": function componentSrcPagesTermsUseJs() {
    return import("./../../src/pages/terms-use.js"
    /* webpackChunkName: "component---src-pages-terms-use-js" */
    );
  },
  "component---src-templates-post-jsx": function componentSrcTemplatesPostJsx() {
    return import("./../../src/templates/post.jsx"
    /* webpackChunkName: "component---src-templates-post-jsx" */
    );
  }
};